import {Grid} from 'antd'
import {TScreenType} from '@/types/common/TScreenType'

export const useScreenType = (): TScreenType => {
    const screens = Grid.useBreakpoint()
    return {
        isDesktop: screens.xl || screens.xxl,
        isLaptop: screens.lg && !screens.xl,
        isTablet: (screens.sm || screens.md) && !screens.lg,
        isMobile: screens.xs && !screens.sm
    }
}
